const WIN = window !== undefined ? window : null

export const get = (key:string) => {
	if (!WIN || !WIN.localStorage || !WIN.localStorage.getItem)
		return null

	return WIN.localStorage.getItem(key) || null
}

export const getObject = (key:string) => {
	const val = get(key)
	if (!val)
		return null

	return JSON.parse(val)
}

export const getDate = (key:string) => {
	const val = get(key)
	if (!val)
		return null

	return new Date(val)
}

export const set = (key:string, val:any) => {
	if (!WIN || !WIN.localStorage || !WIN.localStorage.setItem)
		return null

	const t = typeof(val)
	const value = val === null || val === undefined 
		? '' : t == 'string' 
			? val : (val instanceof Date)
				? val.toISOString() : t == 'object'
					? JSON.stringify(val) : `${val}`

	WIN.localStorage.setItem(key, value)
	return value
}

const localStorage = {
	get,
	getObject,
	getDate,
	set
}

export default localStorage